import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Patient } from '../../../../core/models/patient/patient';
import { PatientInsuranceDetail } from '../../../../core/models/patient/patientInsuranceDetail';
import { CommonService } from '../../../../core/services/v2/common.service';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { UserService } from '../../../../core/services/v2/user.service';
import { UtilsService } from '../../../../core/services/v2/utils.service';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-insurance-edit',
  templateUrl: './patient-insurance-edit.component.html',
  styleUrls: ['./patient-insurance-edit.component.scss']
})
export class PatientInsuranceEditComponent implements OnInit, AfterViewInit {

  @Input() patientInsurance: PatientInsuranceDetail;
  @Input() patientProfile: Patient;
  @Output() patientProfileChange = new EventEmitter<Patient>();
  @Output() toggleEvent = new EventEmitter();
  userId: number;
  errorMessage: string[];
  insuranceCatAr = [

    { itemValue: "1", itemDescription: "Medical" },

    { itemValue: "2", itemDescription: "Dental" },

    { itemValue: "3", itemDescription: "Vision" },

  ];

  insuranceTypeArr = [

    { itemValue: "Primary", itemDescription: "Primary" },

    { itemValue: "Secondary", itemDescription: "Secondary" },

    { itemValue: "Tertiary", itemDescription: "Tertiary" },

  ];

  insurancePlans: any;
  filteredInsurancePlans: Observable<any>;
  insurancePlanCtrl = new FormControl();

  insuranceFrontViewUrl: any;
  insuranceBackViewUrl: any;
  patientInsuranceFormData = new FormData();
  maxDate: Date = new Date();
  minDate: Date = new Date();
  employerId: number;
  employerInsurancePlans: any = [];
  constructor(
    private patientService: PatientService,
    private userService: UserService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private loaderService: WindowLoaderService,
    private utils: UtilsService,
  ) { }


  ngOnInit() {
    this.getUserDetails();
    // this.loadInsurancePlans();
    this.insuranceFrontViewUrl = this.patientInsurance.insurancePlanFrontPictureUrl;
    this.insuranceBackViewUrl = this.patientInsurance.insurancePlanBackPictureUrl;
  }
  ngAfterViewInit() {
    // this.getUserDetails();
  }
  getUserDetails() {
    
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.employerId = userDetails.employerId ? userDetails.employerId : 0;
        if (this.employerId > 0) {
          
          this.commonService.getEmployerInsurancePlans(this.employerId).subscribe((res) => {
            if (res && res.length > 0) {
              this.employerInsurancePlans = [...res];
              if (this.employerInsurancePlans.length > 0) {
                this.employerInsurancePlans.forEach(x => {
                  if (this.employerInsurancePlans.find(p => p.id == x.id) == undefined) {
                    this.employerInsurancePlans.push({ "id": x.id, "name": x.name, "payerId": x.payerId, "transitionTypeId": null });
                  }
                  
                })
                
                this.insurancePlans = [...this.employerInsurancePlans];
                this.filteredInsurancePlans = this.insurancePlanCtrl.valueChanges.pipe(
                  startWith(''),
                  map(value => this._filter(value || '')),
                );

                if (this.patientInsurance.insurancePlanId) {
                  if (this.insurancePlans.find(x => x.id == this.patientInsurance.insurancePlanId) != undefined) {
                    this.insurancePlanCtrl.setValue(this.insurancePlans.find(x => x.id == this.patientInsurance.insurancePlanId).name);
                  }
                }
              }
            }

          });
        }
        else {

          this.loadInsurancePlans();
        }
      },
      (error) => {
        console.error(error);
      },
      () => {
        //   this.loaderService.hide();
      }
    );
  }
  loadInsurancePlans() {
    if (!this.insurancePlans) {
      
      this.commonService.getInsurances().subscribe((res) => {
        this.insurancePlans = res.insurances;
        this.filteredInsurancePlans = this.insurancePlanCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || '')),
        );

        if (this.patientInsurance.insurancePlanId) {
          this.insurancePlanCtrl.setValue(this.insurancePlans.find(x => x.id == this.patientInsurance.insurancePlanId).name);
        }
      });
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.insurancePlans.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  changeFromDate(event) {
    this.minDate = event.target.value;
  }
  attachInsuranceFrontView(event) {
    const file = event.target.files[0];
    const fileType = file.type;
    this.patientInsuranceFormData.append('InsurancePlanFrontPictureFile', file);
    const url = URL.createObjectURL(file);
    this.insuranceFrontViewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.patientInsurance.insurancePlanFrontPictureUrl = this.insuranceFrontViewUrl;
  }

  attachInsuranceBackView(event) {
    const file = event.target.files[0];
    const fileType = file.type;
    this.patientInsuranceFormData.append('InsurancePlanBackPictureFile', file);
    const url = URL.createObjectURL(file);
    this.insuranceBackViewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.patientInsurance.insurancePlanBackPictureUrl = this.insuranceBackViewUrl;
  }


  updatePatientInsurance() {
    this.errorMessage = [];
    if (!this.validData()) {
      return;
    }
    const category = this.insuranceCatAr.find(x => x.itemValue == this.patientInsurance.category.toString()).itemDescription;
    this.patientInsuranceFormData.append('PatientId', this.patientProfile && this.patientProfile.id ? this.patientProfile.id.toString() : this.patientInsurance.patientId.toString());
    this.patientInsuranceFormData.append('Category', category);
    if (this.patientInsurance.id)
      this.patientInsuranceFormData.append('Id', this.patientInsurance.id.toString());

    if (this.patientInsurance.insuranceType)
      this.patientInsuranceFormData.append('InsuranceType', this.patientInsurance.insuranceType);

    if (this.patientInsurance.groupNumber)
      this.patientInsuranceFormData.append('GroupNumber', this.patientInsurance.groupNumber);

    if (this.patientInsurance.memberId)
      this.patientInsuranceFormData.append('MemberId', this.patientInsurance.memberId);
    this.patientInsurance.insurancePlanId = this.insurancePlans.find(x => x.name == this.insurancePlanCtrl.value).id;
    if (this.patientInsurance.insuranceValidFrom) {
      let validFrom = this.utils.getFormatedDate(new Date(this.patientInsurance.insuranceValidFrom));
      this.patientInsuranceFormData.append('InsuranceValidFrom', validFrom);
    }
    if (this.patientInsurance.insuranceValidTo) {
      let validTo = this.utils.getFormatedDate(new Date(this.patientInsurance.insuranceValidTo));
      this.patientInsuranceFormData.append('InsuranceValidTo', validTo);
    }
    this.patientInsuranceFormData.append('InsurancePlanId', this.patientInsurance.insurancePlanId.toString());


    if (this.patientInsurance.memberFullName)
      this.patientInsuranceFormData.append('MemberFullName', this.patientInsurance.memberFullName.toString());
    
    this.patientInsuranceFormData.append('HasHSA', this.patientInsurance.hasHSA?this.patientInsurance.hasHSA.toString():"false");
    this.patientInsuranceFormData.append('HasFSA', this.patientInsurance.hasFSA ? this.patientInsurance.hasFSA.toString() : "false");
    this.patientInsuranceFormData.append('Active', 'true');

    if (this.patientInsurance.id) {
      this.loaderService.blockWithLoader(this.patientService.updatePatientInsurance(this.patientInsuranceFormData)).subscribe(
        (res) => {
          if (res.isSuccess) {
            this.patientService.getCurrentPatientDetails().subscribe(
              (details) => {
                if (details) {
                  this.patientProfile.patientInsurances = details.patientInsurances;
                  this.patientProfileChange.emit(this.patientProfile);
                }
                this.toggleEvent.emit();
                this.loaderService.hide();
              },
              (error) => {
                console.error(error);
                this.loaderService.hide();
              },
              () => {
                this.loaderService.hide();
              }
            );
          } else
            console.error(res);
          this.loaderService.hide();
        },
        (error) => { console.error(error); },
        () => {
          this.loaderService.hide();
        }
      );
    }
    else {
      this.patientService.addPatientInsurance(this.patientInsuranceFormData).subscribe(
        (res) => {
          if (res.isSuccess) {
            this.patientService.getCurrentPatientDetails().subscribe(
              (details) => {
                if (details) {
                  this.patientProfile.patientInsurances = details.patientInsurances;
                  this.patientProfileChange.emit(this.patientProfile);
                }
                this.toggleEvent.emit();
                this.loaderService.hide();
              },
              (error) => {
                console.error(error);
                this.loaderService.hide();
              },
              () => {
                this.loaderService.hide();
              }
            );
          } else
            console.error(res);
          this.loaderService.hide();
        },
        (error) => { console.error(error); },
        () => {
          this.loaderService.hide();
        }
      );
    }
  }

  validData() {
    if (!this.patientInsurance.category)
      this.errorMessage.push("Category is required");
    if (!this.insurancePlanCtrl.value)
      this.errorMessage.push("Insurance plan is required");

    if (this.patientInsurance.insuranceValidFrom || this.patientInsurance.insuranceValidTo) {
      const validFrom = moment(this.patientInsurance.insuranceValidFrom);
      const validTo = moment(this.patientInsurance.insuranceValidTo);
      if (validFrom.isAfter(validTo)) {
        this.errorMessage.push('"Insurance Valid From" can not be more than "Insurance Valid To"');
      }
      this.errorMessage.push();
    }

    if (this.errorMessage.length > 0) {
      this.utils.showMessageSnackBar(this.errorMessage.join('\n'), true);
      return false;
    }

    return true;
  }

  cancel() {
    this.toggleEvent.emit();
  }




}
